module.exports = __webpack_public_path__ + "img/heatsensor_small-min.986d80a3.png";